import React from 'react';
import styles from './Features.module.css';

const Features = () => {
  const features = [
    {
      icon: 'fa-qrcode',
      title: 'QR-код на каждом чеке',
      description: 'Все чеки содержат QR-код для быстрой проверки подлинности'
    },
    {
      icon: 'fa-hotel',
      title: 'От действующих гостиниц',
      description: 'Документы оформляются от реально работающих гостиниц'
    },
    {
      icon: 'fa-file-text',
      title: 'Полный пакет документов',
      description: 'Предоставляем все необходимые документы для отчётности'
    },
    {
      icon: 'fa-truck',
      title: 'Быстрая доставка',
      description: 'Доставка в день заказа по всему городу'
    },
    {
      icon: 'fa-shield',
      title: '100% легальность',
      description: 'Все чеки соответствуют требованиям законодательства'
    },
    {
      icon: 'fa-phone',
      title: 'Круглосуточная поддержка',
      description: 'Консультация и помощь 24/7'
    }
  ];

  return (
    <section id="features" className={`section ${styles.features}`}>
      <div className="container">
        <div className={styles.featuresHeader}>
          <h2 className={styles.sectionTitle}>Почему выбирают нас</h2>
          <p className={styles.sectionSubtitle}>
            Мы обеспечиваем максимальное удобство и надёжность при оформлении командировочных документов
          </p>
        </div>
        
        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.featureIcon}>
                <i className={`fa ${feature.icon}`}></i>
              </div>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;